export const data = [
  {
    id: 1,
    name: "Vans Skate Old Skool",
    category: "Shoes",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001149063_804x.progressive.jpg?v=1677249582",
    price: "£40-£80",
    link: "https://www.routeone.co.uk/products/vans-skate-old-skool-shoes-breana-geering-blue-black-001149063",
  },
  {
    id: 2,
    name: "Adidas Copa Nationale",
    category: "Shoes",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001139939_804x.progressive.jpg?v=1674819703",
    price: "£40-£80",
    link: "https://www.routeone.co.uk/products/adidas-copa-nationale-skate-shoes-white-bluebird-scarlet-001139939",
  },
  {
    id: 3,
    name: "Converse PL Vulc Pro",
    category: "Shoes",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001149262_804x.progressive.jpg?v=1681483287",
    price: "£40-£80",
    link: "https://www.routeone.co.uk/products/converse-pl-vulc-pro-ox-summer-skate-shoes-golden-sundial-white-white-001149262",
  },
  {
    id: 4,
    name: "New Balance Numeric",
    category: "Shoes",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001081246_371d7300-02cc-42bc-bc02-00c396970eed_804x.progressive.jpg?v=1628776024",
    price: "£40-£80",
    link: "https://www.routeone.co.uk/products/new-balance-numeric-foy-306-skate-shoes-black-gum",
  },
  {
    id: 5,
    name: "Supreme Nuns Tee",
    category: "T-Shirts",
    image:
      "https://image.goat.com/transform/v1/attachments/product_template_additional_pictures/images/082/590/773/original/1102595_01.jpg.jpeg?width=500 &height=500 &fit=contain &background=%23fff",
    price: "£80-£120",
    link: "https://stockx.com/en-gb/supreme-nuns-tee-white",
  },
  {
    id: 6,
    name: "Powell Peralta Skeleton",
    category: "T-Shirts",
    image:
      "https://www.natterjacks.com/images/powell-peralta-ripper-t-shirt-p100340-395852_medium.jpg",
    price: "£0-£40",
    link: "https://www.natterjacks.com/clothing-c27/t-shirts-long-sleeves-c11/powell-peralta-ripper-t-shirt-p100340#attribute%5B1%5D=3040",
  },
  {
    id: 7,
    name: "Thrasher Barbarian",
    category: "T-Shirts",
    image:
      "https://www.skatestore.com/thumbnail/f9/cb/ed/1698770627/thrasher-barbarian-t-shirt-white-1_800x800.jpg?ts=1698770695",
    price: "£0-£40",
    link: "https://www.skatestore.com/Thrasher-Barbarian-T-Shirt-White/1126297-M",
  },
  {
    id: 8,
    name: "Rip N Dip Desperado",
    category: "T-Shirts",
    image:
      "https://www.natterjacks.com/images/ripndip-desperado-t-shirt-p115689-583792_image.jpg",
    price: "£0-£40",
    link: "https://www.nativeskatestore.co.uk/skate-clothing-c9/skate-t-shirts-c10/desperado-long-sleeve-skate-t-shirt-black-p63318",
  },
  {
    id: 9,
    name: "Quasi Bledsoe Acid-Ply 8.375",
    category: "SkateBoards",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001155062_804x.progressive.jpg?v=1680254381",
    price: "£80-£120",
    link: "https://www.routeone.co.uk/products/quasi-bledsoe-acid-ply-2-skateboard-deck-8-375-001155062",
  },
  {
    id: 10,
    name: "Primitive x Tupac Posted 8",
    category: "SkateBoards",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001151679_804x.progressive.jpg?v=1674222418",
    price: "£80-£120",
    link: "https://www.routeone.co.uk/products/primitive-x-tupac-posted-skateboard-deck-8-001151679",
  },
  {
    id: 11,
    name: "Deathwish Julian Macabre 8.125",
    category: "SkateBoards",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001155882_804x.progressive.jpg?v=1682087838",
    price: "£80-£120",
    link: "https://www.routeone.co.uk/products/deathwish-julian-macabre-skateboard-deck-8-125-001155882",
  },
  {
    id: 12,
    name: "Chocolate Aikens Disco Toni 8.5",
    category: "SkateBoards",
    image:
      "https://cdn.shopify.com/s/files/1/0274/4293/7933/products/001155945_804x.progressive.jpg?v=1682088501",
    price: "£80-£120",
    link: "https://www.routeone.co.uk/products/chocolate-aikens-disco-toni-pop-secret-skateboard-deck-8-5-001155946",
  },
  {
    id: 13,
    name: "Venture Trucks 8.0",
    category: "Trucks",
    image:
      "https://www.nativeskatestore.co.uk/images/venture-trucks-92-full-bleed-team-hi-5-2-skateboard-trucks-8-0-p63107-142958_medium.jpg",
    price: "£40-£80",
    link: "https://www.nativeskatestore.co.uk/skateboards-c7/skateboard-trucks-c18/92-full-bleed-team-hi-5-2-skateboard-trucks-8-0-p63107",
  },
  {
    id: 14,
    name: "Independent Trucks 8.0",
    category: "Trucks",
    image:
      "https://www.nativeskatestore.co.uk/images/independent-trucks-blackout-stage-11-139-skateboard-trucks-8-0-p63216-143161_medium.jpg",
    price: "£40-£80",
    link: "https://www.nativeskatestore.co.uk/skateboards-c7/skateboard-trucks-c18/blackout-stage-11-139-skateboard-trucks-8-0-p63216",
  },
  {
    id: 15,
    name: "Thunder Trucks 8.5",
    category: "Trucks",
    image:
      "https://www.nativeskatestore.co.uk/images/thunder-trucks-mariano-customs-149-hollow-light-skateboard-trucks-8-5-p63668-144013_medium.jpg",
    price: "£40-£80",
    link: "https://www.nativeskatestore.co.uk/skateboards-c7/skateboard-trucks-c18/mariano-customs-149-hollow-light-skateboard-trucks-8-5-p63668",
  },
  {
    id: 16,
    name: "Krux Trucks 8.25",
    category: "Trucks",
    image:
      "https://www.nativeskatestore.co.uk/images/krux-trucks-fos-eyes-2-k5-dlk-standard-silver-pink-skateboard-trucks-8-25-p62956-142647_medium.jpg",
    price: "£40-£80",
    link: "https://www.nativeskatestore.co.uk/skateboards-c7/skateboard-trucks-c18/fos-eyes-2-k5-dlk-standard-silver-pink-skateboard-trucks-8-25-p62956",
  },
  {
    id: 17,
    name: "GLITTER DENIM",
    category: "Trousers",
    image:
      "https://cdn.shopify.com/s/files/1/0412/0133/6481/files/ESoxgdzk_900x.jpg?v=1682362512",
    price: "£80-£120",
    link: "https://golfwang.com/collections/new/products/light-pleated-trouser-by-golf-wang?variant=42373976719532",
  },
  {
    id: 18,
    name: "LIGHT PLEATED TROUSER",
    category: "Trousers",
    image:
      "https://cdn.shopify.com/s/files/1/0412/0133/6481/files/uSptukBQ_900x.jpg?v=1682363793",
    price: "£100-£150",
    link: "https://cdn.shopify.com/s/files/1/0412/0133/6481/files/uSptukBQ_900x.jpg?v=1682363793",
  },
  {
    id: 19,
    name: "MATCH POINT TRACK PANT",
    category: "Trousers",
    image:
      "https://cdn.shopify.com/s/files/1/0412/0133/6481/files/W9AU5HyU_900x.jpg?v=1682362809",
    price: "£80-£120",
    link: "https://golfwang.com/collections/new/products/match-point-track-pant-by-golf-wang?variant=42373980160172",
  },
  {
    id: 20,
    name: "WASHED CANVAS CARPENTER PANT",
    category: "Trousers",
    image:
      "https://cdn.shopify.com/s/files/1/0412/0133/6481/files/uYpRZucQ_900x.jpg?v=1682363011",
    price: "£80-£120",
    link: "https://golfwang.com/collections/new/products/washed-canvas-carpenter-pant-by-golf-wang?variant=42373978456236",
  },
  {
    id: 21,
    name: "THE BEACHCOMB JACKET",
    category: "Jackets",
    image:
      "https://www.thamesmmxx.com/cdn/shop/files/Beachcomb_Jacket_Front_WEB_900x.png?v=1707233989",
    price: "£120-£160",
    link: "https://www.thamesmmxx.com/collections/all/products/the-beachcomb-jacket",
  },

  {
    id: 22,
    name: "Duck Canvas Deck",
    category: "Jackets",
    image:
      "https://www.workingclassheroes.co.uk/images/products/D/DK/dk0a4xfyc411m09.png?width=1998&height=1998&quality=85&mode=pad&format=webp&bgcolor=ffffff",
    price: "£120-£160",
    link: "https://www.dickieslife.com/uk_en/dc-deck-jacket-0a4xfy-stone-washed-brown-duck",
  },
  {
    id: 23,
    name: "HECTOR P.G.",
    category: "Jackets",
    image:
      "https://www.thamesmmxx.com/cdn/shop/files/pgskeletonfrontnew_WEB_900x.png?v=1712910668",
    price: "£160-£200",
    link: "https://www.thamesmmxx.com/collections/all/products/the-hector-p-g",
  },
  {
    id: 24,
    name: "Chase City Jacket",
    category: "Jackets",
    image:
      "https://media.endclothing.com/media/catalog/product/1/3/13-03-24-si_dk0a4yqsblk1_1.jpg ",
    price: "£160-£200",
    link: "https://www.dickieslife.com/uk_en/chase-city-jacket-0a4yqs-whitecap-grey",
  },
];
